<template>
  <!-- 类目佣金设置编辑 -->
  <div>
    <a-modal
      :title="modalTitle"
      :visible="visible"
      @ok="okFun"
      @cancel="closeFun"
      v-bind="this.$store.state.modalConfig"
    >
      <x-addEdit
        ref="addEdit"
        :itemLayout="$store.state.modal_ItemLayout"
        :formList="formList"
        :initReqHandle = 'initReqHandle'
        :isSubmitBtn="false"
      >
      </x-addEdit>
    </a-modal>
  </div>
</template>

<script>
import { empty } from 'ant-design-vue-admin-x';
import { fetchSelect } from '@/utils/mixins';
export default {
  name: 'categoryCommissionSettings',
  mixins: [fetchSelect],
  components: { },
  data () {
    return {
      IsBatchSetting: false,
      initReqHandle: false,
      modalTitle: '比例设置',
      visible: false,
      categoryId: void 0,

      formList: [
        {
          label: '技术服务费比例',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入技术服务费比例',
          props: ['platformServicePoint', {
            rules: [{ required: true, message: '请输入技术服务费比例' }, {pattern: /^(([1-9]([0-9]{1,1})?(\.[0-9]{1,2})?)|([0]\.[1-9]|0\.0[1-9]|0\.[1-9][0-9])||100||0)$/, message: '请输入0~100的数字'}]
          }],
          suffix: '%'
        },
        {
          label: '分销佣金比例',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入分销佣金比例',
          props: ['commissionPoint', {
            rules: [{ required: true, message: '请输入分销佣金比例' }, {pattern: /^(([1-9]([0-9]{1,1})?(\.[0-9]{1,2})?)|([0]\.[1-9]|0\.0[1-9]|0\.[1-9][0-9])||100||0)$/, message: '请输入0~100的数字'}]
          }],
          suffix: '%'
        },
        {
          label: '积分返还比例',
          inputType: 'input',
          options: [],
          handle: '',
          placeholder: '请输入积分返还比例',
          props: ['pointsPoint', {
            rules: [{ required: true, message: '请输入积分返还比例' }, {pattern: /^(([1-9]([0-9]{1,1})?(\.[0-9]{1,2})?)|([0]\.[1-9]|0\.0[1-9]|0\.[1-9][0-9])||100||0)$/, message: '请输入0~100的数字'}]
          }],
          suffix: '%'
        }
      ]
    };
  },
  created () {
  },
  methods: {
    okFun () {
      this.$refs.addEdit.form.validateFields((err, values) => {
        if (err) { return; }
        if (this.IsBatchSetting) {
          this.$put({
            url: '/local/category/batchEdit',
            params: {
              ...values,
              categoryId: this.categoryId
            }
          }).then((res) => {
            this.$message.success(res.msg);
            empty.$emit('refreshCommissionList');
            this.visible = false;
          });
        } else {
          this.$put({
            url: '/local/category/' + this.categoryId,
            params: values
          }).then((res) => {
            this.$message.success(res.msg);
            empty.$emit('refreshCommissionList');
            this.visible = false;
          });
        }
      });
    },
    closeFun () {
      this.visible = false;
    },
    show (row, multiple) {
      if (multiple) {
        this.IsBatchSetting = true;
        this.visible = true;
        this.categoryId = row;
        let obj = {
          platformServicePoint: 0,
          commissionPoint: 0,
          pointsPoint: 0
        };
        setTimeout(() => {
          this.$refs.addEdit.form.setFieldsValue(obj);
        }, 100);
      } else {
        this.IsBatchSetting = false;
        this.visible = true;
        this.categoryId = row.categoryId;
        let obj = {
          platformServicePoint: row.platformServicePoint,
          commissionPoint: row.commissionPoint,
          pointsPoint: row.pointsPoint
        };
        setTimeout(() => {
          this.$refs.addEdit.form.setFieldsValue(obj);
        }, 100);
      }
    }
  }
};
</script>
<style lang="less" scoped>
</style>
